// Base stylesheet needed for every page
import './scss/app.scss';

require('./scripts/filters');
require('./scripts/nav');
require('./scripts/footer');
require('./scripts/product');
require('./scripts/product-tabs');
require('./scripts/variant-select-popup');
require('./scripts/variant-selector-alt');
require('./scripts/image-popup');
require('./scripts/single-image-popup');
require('./scripts/language-switch');
require('./scripts/searchform');
require('./scripts/slider');
require('./scripts/cart');
require('./scripts/minicart');
require('./scripts/cookiebar');
require('./scripts/mailchimp');
require('./scripts/video');
